import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-roll",
  "use": "icon-roll-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-roll\"><path d=\"M512 993.415168l275.093504-412.64128H236.906496zM512 30.584832L236.906496 443.226112h550.187008z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol